import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CollapsibleCard from 'Components/ComponentLibrary/Components/Uncategorized/CollapsibleCard/CollapsibleCard';
import DataContainer from 'Components/UI/DataContainer';
import fr from 'facet-rest';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import InvestmentReturnsContent from './Content';

const useStyles = buildUseStyles('InvestmentReturnsSection', () => ({
  root: {},
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));

const InvestmentReturnsSection = ({
  className,
  modelPerformanceDataRelationshipLink,
  modelPerformanceChartDataRelationshipLink,
}) => {
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState(null);
  const [modelPerformanceData, setModelPerformanceData] = useState(null);
  const [modelPerformanceChartData, setModelPerformanceChartData] = useState(null);
  const theme = useTheme();
  const classes = useStyles(theme);

  const fetchModelPerformanceData = async () => {
    setLoading(true);
    try {
      const modelPerformanceDataCollection = modelPerformanceDataRelationshipLink.get();
      const modelPerformanceChartDataCollection = modelPerformanceChartDataRelationshipLink.get();

      const responses = await Promise.all([
        modelPerformanceDataCollection,
        modelPerformanceChartDataCollection,
      ]);
      setModelPerformanceData(responses[0]);
      setModelPerformanceChartData(responses[1]);
    } catch (e) {
      setErrors(e);
    }
    setLoading(false);
  };

  const onClick = async () => {
    if (modelPerformanceData === null || modelPerformanceChartData === null || errors !== null) {
      await fetchModelPerformanceData();
    }
  };

  useComponentDidMount(async () => {
    await fetchModelPerformanceData();
  });

  return (
    <CollapsibleCard
      title={'Investment Returns'}
      className={classNames(className, classes.card)}
      onClick={onClick}
    >
      {!errors && (
        <DataContainer
          component={InvestmentReturnsContent}
          componentProps={{
            modelPerformanceData,
            modelPerformanceChartData,
          }}
          loading={loading}
        />
      )}
    </CollapsibleCard>
  );
};

InvestmentReturnsSection.defaultProps = {
  className: '',
};

InvestmentReturnsSection.propTypes = {
  className: PropTypes.string,
  modelPerformanceDataRelationshipLink: PropTypes.instanceOf(fr.Link).isRequired,
  modelPerformanceChartDataRelationshipLink: PropTypes.instanceOf(fr.Link).isRequired,
};

export default InvestmentReturnsSection;
